export default {
	data:null,
	title:null
}


// WEBPACK FOOTER //
// ./src/store/ltcat/state.js